//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.BlendSetbackBuilderList.js";
import "../GeometricUtilities/GeometricUtilities.TransitionCurveBuilderList.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/ObjectList.js";
let d=[[[0,"AllowTransitionCurveOnBlends",1,0],[0,"AngleTolerance",1,0],[0,"CenterPoint",1,"Point",0],[0,"Continuity",1,0],[0,"DistanceTolerance",1,0],[1,"Fullness",0,"Expression",0],[1,"LimitCurveList",0,"GeometricUtilities.BlendSetbackBuilderList",0],[0,"SewToBody",1,0],[1,"TransitionCurveList",0,"GeometricUtilities.TransitionCurveBuilderList",0],[0,"UseCenterPoint",1,0]],[[[],"CreateBlendSetbackBuilder",{R_:{setbackBuilder:"GeometricUtilities.BlendSetbackBuilder"}},0,0],[[],"CreateTransitionCurveBuilder",{R_:{transitionCurve:"GeometricUtilities.TransitionCurveBuilder"}},0,0]],[]];
SPLM.Features.BlendCornerBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.BlendCornerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.BlendCornerBuilder.ContinuityTypes = Object.freeze({
    "G1" : "G1", "G2" : "G2"});

export default SPLM;